import React from 'react';


function AddProperty () {
    return(
        <div className="contact_action_area" id="add-property">
            <div className="container">
                <div className="row">
                    <div className="col-xl-7">
                        <div className="action_heading">
                            <h3>Add your property for sale</h3>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <div className="call_add_action">
                            <span>+91 123 123 1234</span>
                            <a href="" className="boxed-btn3-line">Add Property</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) 
}

export default AddProperty;